<template>
  <div>
    <el-row class="marginBottom10">
      <el-col :span="8">{{ $t('cost.cost094') }}</el-col><!-- 常用项目 -->
      <el-col :span="8">{{ $t('cost.cost095') }}</el-col><!-- 选择项目 -->
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-tag class="project-item marginRight10 marginBottom10" @click="setProject(projectBO, index)" v-for="(projectBO,index) in commonProject" :key="projectBO.projectId">{{projectBO.projectName}}</el-tag>
      </el-col>
      <el-col :span="8">
        <el-table :data="projectTypeList" border :show-header="false" height="500" @row-click="projectTypeClick">
          <el-table-column prop="itemName"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="8">
        <el-table :data="projectList" border :show-header="false" height="500" @row-click="setProject" v-if="projectList && projectList.length">
          <el-table-column prop="projectName"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "ProjectSelectTab",
    props: {
      commonProject: {
        type: Array,
        default() {
          return []
        }
      },
      projectTypeList: {
        type: Array,
        default() {
          return []
        }
      },
      projectList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {

      }
    },
    methods: {
      setProject(projectBO) {
        this.$emit('setProject', projectBO)
      },
      projectTypeClick(projectTypeBO) {
        this.$emit('projectTypeClick', projectTypeBO)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .project-item {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
